import { Component } from '@opten/compiler/metadata/component';
import { MenuTrigger } from '.';
import { OnInit } from '@opten/compiler/metadata/lifecycle';

@Component({ className: 'js-menu-trigger', observe: true })
export class MenuTriggerComponent implements OnInit {
	private menuTrigger: MenuTrigger;

	constructor(private element: HTMLElement) {}

	onInit(): void {
		this.menuTrigger = new MenuTrigger(this.element);

		this.element.addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();

			this.menuTrigger.toggle();
		});
	}
}
